export const TEXT = {
    labels: { id: "ID" },
    addSection: "افزودن سرفصل",
    sectionSettings: "مشخصات سرفصل",
    contentsHeader: "محتوای سرفصل",
    addContent: "اضافه کردن محتوا",
    noContents: "هنوز هیچ محتوایی برای این سرفصل تعریف نشده است.",
    buttons: {
        cancel: "لغو",
        save: "ذخیره",
        saveNew: "افزودن سرفصل",
    },
    switch: {
        active: "فعال",
        inactive: "غیرفعال",
    },
} as const;

export interface Section {
    id: string;
    position: number;
    description: string;
    version: number;
    is_active: boolean;
    course_id: string; // Course ids are strings, like "python-basics"
    contents: unknown[];
}

export const defaultNewSection = (courseId: string): Section => ({
    id: "",
    position: 0,
    description: "",
    version: 1,
    is_active: true,
    course_id: courseId,
    contents: [],
});

export const CONTENT_TYPE = {
    LESSON: 0,
    PROJECT: 1,
} as const;

export type ContentType =
    (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

export const BLOCK_TYPES = [
    { type: "text", label: "متن" },
    { type: "heading", label: "سرتیتر" },
    { type: "image", label: "تصویر" },
    { type: "question_single_choice", label: "تک‌گزینه‌ای" },
    { type: "question_multiple_choice", label: "چندگزینه‌ای" },
    { type: "list", label: "لیست" },
    { type: "info", label: "دانستنی" },
    { type: "warning", label: "هشدار" },
    { type: "code", label: "کد" },
    { type: "code_web", label: "کد وب" },
    { type: "code_fill", label: "کد ادیت" },
    { type: "placeholder_code", label: "کد جای‌خالی" },
] as const;

export type BlockType = (typeof BLOCK_TYPES)[number]["type"];

export const LANGUAGES = [
    "python",
    "html",
    "css",
    "javascript",
    "typescript",
    "java",
    "cpp",
    "c",
    "go",
    "rust",
    "php",
] as const;

export type Language = (typeof LANGUAGES)[number];

export const RUNNERS_BY_TYPE = {
    program: ["python", "node", "java", "cpp"],
    sql: ["sqlite"],
    web: ["web-preview"],
} as const;

export type RunnerType = keyof typeof RUNNERS_BY_TYPE;

const DIFFICULTY_LABELS: Record<number, string> = {
    0: "مبتدی",
    1: "متوسط",
    2: "حرفه‌ای",
};

// Returns an empty string for unknown values,
// so the badge can hide itself.
export const getDifficultyLabel = (
    difficulty?: number
): string => {
    return difficulty === undefined
        ? ""
        : DIFFICULTY_LABELS[difficulty] ?? "";
};

